import { Play, Music2, Globe } from "lucide-react";
import { cn } from "@/lib/utils";

// Tiles de plataforma con color de marca (rediseño 2026-07-02).
// Siguen siendo iconos locales (Lucide/texto), sin imágenes externas.
const BRAND = {
  YouTube: { cls: "bg-red-600 text-white", icon: Play, fill: true },
  TikTok: { cls: "bg-stone-900 text-white dark:bg-stone-800", icon: Music2 },
  X: { cls: "bg-black text-white dark:bg-stone-950", letter: "X" },
  Web: { cls: "bg-sky-700 text-white", icon: Globe },
};

const SIZES = {
  mini: "w-9 h-9 rounded-lg",
  row: "w-11 h-11 rounded-lg",
  card: "w-full aspect-[16/10] rounded-t-lg",
  hero: "w-full aspect-video rounded-lg",
};

const ICON_SIZE = { mini: "h-4 w-4", row: "h-5 w-5", card: "h-10 w-10", hero: "h-12 w-12" };
const LETTER_SIZE = { mini: "text-sm", row: "text-base", card: "text-4xl", hero: "text-5xl" };

export const Thumb = ({ platform, size = "row", className }) => {
  const brand = BRAND[platform] || BRAND.Web;
  const Icon = brand.icon;
  return (
    <div
      className={cn("relative shrink-0 grid place-items-center overflow-hidden", brand.cls, SIZES[size], className)}
    >
      {brand.letter ? (
        <span className={cn("font-black leading-none", LETTER_SIZE[size])}>{brand.letter}</span>
      ) : (
        <Icon
          className={ICON_SIZE[size]}
          strokeWidth={brand.fill ? 0 : 1.75}
          fill={brand.fill ? "currentColor" : "none"}
        />
      )}
      {(size === "card" || size === "hero") && (
        <span className="absolute bottom-2 left-2 rounded-full bg-background/95 border px-2 py-0.5 text-[11px] font-medium text-foreground">
          {platform}
        </span>
      )}
    </div>
  );
};
